.<template>
  <!-- 开发流程 -->
  <div class="developmentProcess" id="developmentProcess">
    <div class="developmentProcess-top">
      <img src="../assets/bigTy.png" alt="" /><span>{{
        developmentProcessList.name
      }}</span>
    </div>
    <div class="developmentProcess-main">
      <div
        class="developmentProcess-mainBox"
        v-for="(item, index) in developmentProcessList.lists"
        :key="index"
      >
        <img :src="item.icon" alt="" />
        <div class="mainBox-title">
          <div class="dian"></div>
          <span>{{ item.name }}</span>
          <div class="dian"></div>
        </div>
        <div class="mainBox-bottom">
          <span v-for="(itemText, indexText) in item.lists" :key="indexText">{{
            itemText
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "developmentProcess",
  props: {
    developmentProcessList: {
      type: Object
    }
  },
  data() {
    return {
      itemList: {}
    };
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.developmentProcess {
  background-color: #fff;
  padding-top: 42px;
  padding-bottom: 64px;
}
.developmentProcess-top {
  text-align: center;
  position: relative;
  border-bottom: 1px solid #d6dbdd;
  padding-bottom: 114px;
}
.developmentProcess-top img {
  position: absolute;
  top: -14px;
  left: 776px;
}
.developmentProcess-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.developmentProcess-main {
  width: 1120px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  top: -62px;
}
.developmentProcess-mainBox {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  z-index: 998;
  text-align: center;
}
.developmentProcess-mainBox img {
  display: block;
  width: 31px;
  height: 30px;
  margin: 0 auto;
  margin-bottom: 21px;
}
.mainBox-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.mainBox-title .dian {
  width: 5px;
  height: 5px;
  background: #ff4242;
  border-radius: 50%;
}
.mainBox-title span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin: 0 10px;
}
.mainBox-bottom {
  display: flex;
  flex-direction: column;
}
.mainBox-bottom span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/DevelopmentProcess.vue